module.exports = __webpack_public_path__ + "img/T5-A-rc_2.22bfa21a.png";